import SerieTamisDetailController from './serie.tamis.detail.controller';

export default {
    template: require('./serie.tamis.detail.html'),
    controller: SerieTamisDetailController
};
